import {
  CheckCircleOutlined,
  PayCircleOutlined,
  QrcodeOutlined,
  ScanOutlined,
} from '@ant-design/icons';
import { Space } from 'antd';
import BigNumber from 'bignumber.js';
import React, { useEffect } from 'react';
import { usePrevious } from 'react-use';
import { isGrouponPaymentChannel, PaymentChannel } from '@/models/payment';
import { User } from '@/models/user';
import styles from './style.less';

type Props = {
  onChange?: (value: number) => void;
  value?: number;
  user: User;
  balancePayAvailable?: boolean;
  actualPrice?: BigNumber;
};

const PaymentChannelSelector: React.FC<Props> = ({ onChange, value, actualPrice }: Props) => {
  const isInvalidPaymentChannel = actualPrice && actualPrice.isLessThanOrEqualTo(0);
  const isPrevInvalid = usePrevious(isInvalidPaymentChannel);

  useEffect(() => {
    if (isInvalidPaymentChannel) {
      onChange(PaymentChannel.INVALID);
    } else if (isPrevInvalid) {
      onChange(PaymentChannel.Online);
    }
  }, [isInvalidPaymentChannel, isPrevInvalid]);

  if (isInvalidPaymentChannel) {
    return null;
  }

  return (
    <div className={styles.payMethodSelector}>
      <Space size={10}>
        <div
          className={`${styles.payMethodSelectorItem} ${
            value === PaymentChannel.Online ? styles.active : ''
          }`}
          onClick={() => {
            onChange(PaymentChannel.Online);
          }}>
          <ScanOutlined /> <span>扫码收款</span>
          <CheckCircleOutlined className={styles.payMethodSelectorItemIcon} />
        </div>
        <div
          className={`${styles.payMethodSelectorItem} ${
            value === PaymentChannel.Cash ? styles.active : ''
          }`}
          onClick={() => {
            onChange(PaymentChannel.Cash);
          }}>
          <PayCircleOutlined /> <span>现金收款</span>
          <CheckCircleOutlined className={styles.payMethodSelectorItemIcon} />
        </div>
        <div
          className={`${styles.payMethodSelectorItem} ${
            isGrouponPaymentChannel(value) ? styles.active : ''
          }`}
          onClick={() => {
            onChange(PaymentChannel.Groupon_MT);
          }}>
          <QrcodeOutlined /> <span>团购验券</span>
          <CheckCircleOutlined className={styles.payMethodSelectorItemIcon} />
        </div>
        {/* {canUseBalance && balancePayAvailable && (
          <div
            className={`${styles.payMethodSelectorItem} ${
              value === PaymentChannel.Balance ? styles.active : ''
            }`}
            onClick={() => {
              onChange(PaymentChannel.Balance);
            }}>
            <WalletOutlined /> <span>余额收款</span>
            <CheckCircleOutlined className={styles.payMethodSelectorItemIcon} />
          </div>
        )} */}
      </Space>
    </div>
  );
};

export default PaymentChannelSelector;
